import RelatedHub from '../../related/_hub';

// Related sites hub (EN). Body: _hub.tsx; cards: src/data/related; FAQ: src/data/faq.json (/en/related).
export default function EnRelatedHubPage() {
  return <RelatedHub lang="en" />;
}
